export enum FeedbackType {
    CORRECT_MOVE = 'correctMove',
    INCORRECT_MOVE = 'incorrectMove',
    HINT_USED = 'hintUsed',
    SOLUTION_SHOWN = 'solutionShown',
    PUZZLE_SOLVED = 'puzzleSolved',
    PUZZLE_FAILED = 'puzzleFailed',
}

const FEEDBACK_MESSAGES = {
    [FeedbackType.CORRECT_MOVE]: [
        "Nicely played!",
        "Great move!",
        "You’re on track!",
        "That’s the idea!",
        "Well spotted!",
        "Sharp choice, the board approves.",
        "Clean execution; your idea landed well.",
        "Your intuition struck the right square.",
        "Excellent move, your memory and logic synced beautifully.",
        "A disciplined, brain-boosting choice.",
    ],
    [FeedbackType.INCORRECT_MOVE]: [
        "Try again!",
        "Not quite.",
        "Think again.",
        "A small detour, adjust and continue.",
        "The idea was close, refine and try again.",
        "Try a new angle on the position.",
        "Rethink and push forward.",
        "Good idea, but there's an even stronger move available.",
        "Not quite, it's a different idea.",
        "Not quite right, adjust.",
        "Take a second, then try again.",
        "Close, there's a stronger move here.",
    ],
    [FeedbackType.HINT_USED]: [
        "Smart use of hint!",
        "Clever choice, learning accelerates with every nudge.",
        "A helpful spark that clarifies the path.",
        "Smart players use every advantage to learn faster.",
        "Smart assist, great minds know when to look deeper.",
        "Good use of resources.",
        "Nicely done.",
        "Tips help you learn faster.",
        "Smart to rely on a tip for this one.",
        "Smart assist, keep going.",
    ],
    [FeedbackType.SOLUTION_SHOWN]: [
        "Smart move exploring solutions!",
        "A clear path revealed, study and grow.",
        "Seeing the solution strengthens future insight.",
        "Studying solutions builds deep discipline.",
        "You gained valuable patterns for future puzzles.",
        "Good choice, understanding blooms through clarity.",
        "Knowledge unlocked; treat it as training fuel.",
        "Solution viewed, your brain connects the patterns.",
        "Insight gained, your next attempt will be sharper.",
        "Learning from the answer boosts long-term memory.",
    ],
    [FeedbackType.PUZZLE_SOLVED]: [
        "Puzzle completed!",
        "Well done!",
        "Solved it!",
        "Great job!",
        "Nicely finished!",
        "You cracked it, well played.",
        "Clean finish, your brain leveled up today.",
        "Puzzle mastered, onward to the next challenge.",
        "Well done, your strategy shined to the end.",
        "Victory earned through focus and clarity.",
    ],
    [FeedbackType.PUZZLE_FAILED]: [
        "Better luck next time.",
        "Keep trying!",
        "Learning moment!",
        "Practice makes perfect!",
        "A tough one, but progress hides in the attempt.",
        "Puzzle failed, even grandmasters slip sometimes!",
        "A setback, not a stop.",
        "Incorrect, but every attempt helps you improve.",
        "Not the solution, but you’re improving with every try!",
        "Even unsolved puzzles strengthen your intuition.",
    ],
}

const getFeedbackMessage = (type: FeedbackType): string => {
    const messages = FEEDBACK_MESSAGES[type]
    return messages[Math.floor(Math.random() * messages.length)]
}

export default getFeedbackMessage